import { Injectable, Injector, Renderer2 } from '@angular/core';
import { UsuarioDaoService } from '../dao/usuario-dao.service';
import { NavigateService } from './navigate.service';
import { GlobalsService } from './globals.service';

@Injectable({
  providedIn: 'root'
})
export class EditorService {

  public userDAO?: UsuarioDaoService;
  public sourceData?: any;
  public usuariosMention?: any;
  public query?: any;
  public go: NavigateService;
  public url: string;
  public urlError: string;

  constructor(public injector: Injector, public gb:GlobalsService) {
    this.url = this.gb.servidorURL + "/assets/images/profile.png";
    this.urlError = this.gb.servidorURL + "/assets/images/profile.png";
    this.userDAO = injector.get<UsuarioDaoService>(UsuarioDaoService);
    this.go = injector.get<NavigateService>(NavigateService);
    this.usuariosMention = {
      mentions_selector: '.mymention',
      insertFrom: 'matricula',
      delimiter: '@',
      queryBy:["nome" , "email" , "apelido", "matricula"],
      source: this.usuarioMentionSource.bind(this),
      render: this.usuarioMentionRender.bind(this.usuariosMention),
      insert: this.usuarioMentionInsert.bind(this.usuariosMention),
      renderDropdown: this.usuarioMentionRenderDropDown.bind(this.usuariosMention),
      highlighter: this.usuarioMentionHighlighter.bind(this.usuariosMention)
    };
  }

  public usuarioMentionRender = (item: any): string => {
    return  `
      <li>
        <a href="javascript:;" style="text-decoration:none;">
          <div onmouseout="$('.card').css('background-color', 'white')" onmouseover="this.style.backgroundColor = 'lightgrey'" class="card" style="border:none;display:flex;flex-direction:row;max-width:350px;height:auto;background: white;border: 1px solid #ccc;border-radius:3px;box-shadow:0 4px 8px 0 rgba(34, 47, 62, .1);padding:8px;font-size:14px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;">
            <img class="avatar" onerror="this.onerror=null" src="` + (item.url_foto || "assets/images/profile.png") + `" style="width:auto;height:35px;float:left;margin-right:8px;border-radius:50%;"/>
            <div style="display:flex;flex-direction:column;border:none;">
              <h1 style="font-size:14px;font-weight:bold;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;">` + item.nome + `</h1>
              <span style="font-size:10px;font-weight:bold">` + item.apelido + `</span>
              <span style="font-size:12px;">` + item.email + `</span>
            </div>
          </div>
        </a>
      </li>`;
  }

  public bindProfileClick(dom: HTMLElement, renderer: Renderer2, unlisteners: (() => void)[]) {
    var spans = $("[data-user]", dom);
    spans.each(index => {
      let id = $(spans[index]).attr("data-user") as string;
      let factory = (id: string) => (() => this.showProfileInformation(id)).bind(this);
      $(spans[index]).css("pointer-events", "auto");
      $(spans[index]).css("cursor", "pointer");
      unlisteners.push(renderer.listen(spans[index], 'click', factory(id)));
    });
  }

  public showProfileInformation = (id: string) => {
    //console.log(id);
    this.go.navigate({ route: ['uteis', 'mention', 'detalhe',id] }, {
      metadata: {
        id: id
      }
    })

  }

  public usuarioMentionSource(query: any, process: any, delimiter: any) {
    if (delimiter === '@') {
      this.userDAO?.searchText(query, ["nome" , "email" , "apelido", "matricula"], [], [["nome", "asc"]], 10).then( (result: any) => {
        this.sourceData = result.map((x: any) => 
        (Object.assign({}, {nome: x.text.split('-')[0].trim(), email: x.text.split('-')[1].trim(), apelido: x.text.split('-')[2].trim(), matricula: x.text.split('-')[3].trim(), id: x.value, image:'../../assets/images/avat2.jpg'})))
        process(this.sourceData);
      });
    }
  }

  public usuarioMentionInsert = (item: any): string => {
    return '<span class="nonedit spanID" data-user="'+ item.id +'"style="pointer-events: none;background-color: lightgray;border-radius:12px;padding:0px 5px 0px 5px" onclick="onClickhtml($this)">' + item.nome + '</span>';
  };

  public usuarioMentionRenderDropDown = () => {
    return '<ul class="rte-autocomplete dropdown-menu" style="z-index: 9999!important;border:none;"></ul>';
  };

  public usuarioMentionHighlighter = (text:string) => {
    return text.replace(new RegExp('(' + this.query + ')', 'ig'), function ($1, match) {
      return '<i>' + match + '</i>';
    });
  };

  public onError(event: ErrorEvent) {
    (event.target as any).src = this.urlError;
  }

}